import { createRouter, createWebHistory } from "vue-router";
import NotFoundPage from "src/pages/NotFoundPage";
import Register from "src/pages/Frontend/Registration.vue";
import Login from "src/pages/Frontend/Login.vue";
import AuthLayout from "src/pages/AuthLayout";
import store from "src/store";
import axios from "axios";
import NewTask from "src/pages/Backend/task/NewTask.vue";
// import ContactUs from "src/pages/Frontend/ContactUs";
// import ConfirmRegistration from "src/pages/Frontend/ConfirmRegistration";
// import ResetPassword from "src/pages/Frontend/ResetPassword";
import BackLayout from "src/pages/Backend/BackLayout";
// import EmailVerification from "src/pages/Backend/completeRegistration/EmaiVerification";
import TermsAndConditions from "src/pages/Frontend/TermsAndConditions";
import PrivacyPolicy from "src/pages/Frontend/PrivacyPolicy";
import CookiePolicy from "src/pages/Frontend/CookiePolicy";
import {Role} from "src/role";
import ListTasks from "../pages/Backend/task/ListTasks.vue";
import ShowTask from "../pages/Backend/task/ShowTask.vue";
// import SignUpLogIn from "src/pages/Frontend/SignUpLogIn";



let frontend = {
  path: "/",
  component: AuthLayout,
  name: "Layout",
  redirect: "/login",
  meta: {
    requiresAuth: false,
  },
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    // {
    //   path: "/signup",
    //   name: "SignUp",
    //   component: SignUpLogIn,
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },
    // {
    //   path: "/contact_us",
    //   name: "ContactUs",
    //   component: ContactUs,
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },
    // {
    //   path: "/terms",
    //   name: "TermsAndConditions",
    //   component: TermsAndConditions,
    //   meta: { requiresAuth: false },
    // },
    // {
    //   path: "/privacy_policy",
    //   name: "PrivacyPolicy",
    //   component: PrivacyPolicy,
    //   meta: { requiresAuth: false },
    // },
    // {
    //   path: "/cookie_policy",
    //   name: "CookiePolicy",
    //   component: CookiePolicy,
    //   meta: { requiresAuth: false },
    // },
    // {
    //   path: '/confirm_registration/:userId/:registrationString',
    //   name: 'confirm_registration',
    //   component: ConfirmRegistration,
    //   meta: { requiresAuth: false }
    // },
    // {
    //   path: '/reset_password/:userId/:registrationString',
    //   name: 'reset_password',
    //   component: ResetPassword,
    //   meta: { requiresAuth: false }
    // },
  ],
};


// let dashboard = {
//   path: "/dashboard",
//   component: BackLayout,
//   meta: {
//     requiresAuth: true,
//   },
//   children: [
//     {
//       path: "",
//       name: "Dashboard",
//       component: Dashboard,
//       meta: {
//         requiresAuth: true,
//       },
//     },
//   ]
// };



let tasks = {
  path: "/task",
  component: BackLayout,
  meta: {
    requiresAuth: true
  },
  redirect: "/task/new",
  children: [
    {
      path: "new",
      name: "NewTask",
      component: NewTask,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "list",
      name: "ListTask",
      component: ListTasks,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "show/:id",
      name: "ShowTask",
      component: ShowTask,
      meta: {
        requiresAuth: true
      }
    }
  ]
};



// let manager = {
//   path: "/manager",
//   component: BackLayout,
//   meta: {
//     requiresAuth: true,
//     requiresRole: Role.Manager
//   },
//   redirect: "/manager/users_stats",
//   children: [
//     {
//       path: "users_stats",
//       name: "UsersStats",
//       component: UsersStats,
//       meta: {
//         requiresAuth: true,
//         requiresRole: Role.Manager
//       },
//     },
//     {
//       path: "handle_user/:id",
//       name: "HandleUser",
//       component: ManageUser,
//       meta: {
//         requiresAuth: true,
//         requiresRole: Role.Manager
//       },
//     },
//   ]
// };


const routes = [
  frontend,
  tasks,
  // dashboard,
  // manager,
  { path: '/:pathMatch(.*)*', name: "NotFound", component: AuthLayout, children: [{path: "", component: NotFoundPage, name: "NotFound"}] },
];

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  routes,
});

router.beforeEach(async (to, from) => {
  // in this way, extract the variable requireRole from to.meta, not all the attributes of to.meta!
  const { requiresRole } = to.meta;
  let loggedUser = store.getters.isLoggedIn;

  // name of the routes to avoid if the user is already logged in
  // note: confirm_registration can be accessed also if the user is loggedIn.
  let listSpecialPaths = ["Register", "Login", "SignUp", "reset_password"];

  if (!to.meta.requiresAuth && !listSpecialPaths.includes(to.name))
    return true;

  if (!loggedUser) {
    await axios
      .post(process.env.VUE_APP_SERVER_BASE_URL + "me/", {})
      .then((response) => {
        store.commit("auth_success", response.data.user);
        loggedUser = true;
      })
      .catch((error) => {});
  }

  if (!loggedUser && !to.meta.requiresAuth) return true;

  // redirect to login page if not logged in and trying to access a restricted page
  if (!loggedUser && to.meta.requiresAuth)
    return { path: "/login", query: { redirect: to.path } };

  // redirect to dashboard if the user is logged in and is trying to access to a "special path".
  if (listSpecialPaths.includes(to.name) && loggedUser)
      return "/task/list";


  // if we need an array of roles to check, use this:
  // let checker = (arr, target) => target.every(v => arr.includes(v));

  // check if route is restricted by role
  if (requiresRole && !store.getters.hasRole(requiresRole))
    return false; // role not authorized


  return true;
});

export default router;
